import { useState, useEffect, useMemo } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import sanityClient from "../../sanityClient";

export default function HomeServices({ isAboutPage }) {
  const [services, setServices] = useState([]);

  // Fetch services from Sanity
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await sanityClient.fetch(
          `*[_type == "service" && showOnHome== true && !defined(deletedAt)] | order(createdAt desc) {
            title,
            "slug": slug.current,
            "imageUrl": image.asset->url
          }`
        );
        setServices(data);
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };

    fetchServices();
  }, []);

  // Memoized Slider Settings
  const sliderSettings = useMemo(
    () => ({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 1400,
      autoplaySpeed: 4000,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      pauseOnHover: false,
      cssEase: "ease",
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            autoplay: true,
            dots: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            autoplay: true,
            dots: true,
          },
        },
        {
          breakpoint: 599,
          settings: {
            slidesToShow: 1,
            autoplay: true,
            dots: true,
          },
        },
      ],
    }),
    []
  );

  return (
    <section className="home-service">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h4 className="heading center-heading">Our Services</h4>
          </div>

          <div className="col-lg-12">
            <Slider className="service-slider" {...sliderSettings}>
              {services.slice(0, 3).map((service, index) => (
                <div className="service-box" key={service.slug || index}>
                  <Link to={`/${service.slug}`}>
                  
                    <img src={service.imageUrl} className="img-responsive" alt={service.title} loading="lazy" width="100%" height="auto"/>
                    <img src="/assets/home/light-curve.svg" className="service-curve" alt="shape" loading="lazy" width="100%" height="auto"/>

                    <div>
                      <h4>{service.title}</h4>
                      <span>Explore</span>
                    </div>
                  </Link>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
}
